import { AdminType, APIDelete, APIGet, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

export interface ICustomerLotteryRequest {
    id: number;
    allow_time_preference_window: number;
    close_date: string;
    created_at: string;
    customer_id_one: number;
    customer_id_two: number;
    customer_id_three: number;
    customer_id_four: number;
    customer_one: {id: number; full_name: string};
    customer_two: {id: number; full_name: string};
    customer_three: {id: number; full_name: string};
    customer_four: {id: number; full_name: string};
    date: string;
    facility_id: number;
    facility_name: string;
    course_id: number;
    holes: number;
    lottery_id: number;
    quantity: number;
    start_time_preference_one: string;
    start_time_preference_two: string;
    start_time_preference_three: string;
    start_time_preference_window: number;
}

export interface IPutLotteryRequestParams {
    id: number;
    customer_id: number;
    customer_id_one: number;
    customer_id_two: number;
    customer_id_three: number;
    customer_id_four: number;
    start_time_preference_window: number;
    holes: number;
    quantity: number;
    start_time_preference_one: string;
    start_time_preference_two: string;
    start_time_preference_three: string;
}

export async function CustomerGetLotteryRequest(
    params: {limit?: number; offset?: number, guest?: boolean},
    useGlobalLoader: boolean,
    cancelToken?: CancelToken,
  ) {
    return await APIGet<Array<ICustomerLotteryRequest>>(APIUrl(AdminType.Customer, "/tee-sheet/lottery/request"), params, useGlobalLoader, cancelToken);
  }

  export async function CustomerPutLotteryRequest(
    params: IPutLotteryRequestParams,
    useGlobalLoader: boolean,
  ) {
    return await APIPut(APIUrl(AdminType.Customer, "/tee-sheet/lottery/request"), params, useGlobalLoader);
  }

  export async function CustomerDeleteLotteryRequest(
    params: {id: number},
    useGlobalLoader: boolean,
  ) {
    return await APIDelete(APIUrl(AdminType.Customer, "/tee-sheet/lottery/request"), params, useGlobalLoader);
  }